import React from 'react';

import { Spacer } from '@/components/common';
import { Text } from '@/components/memo';

import './Header.css';

const Header: React.FC = () => {
  const copy = {
    title: (
      <>
        <Text color="primary">Level up</Text> your practice!
      </>
    ),
    description: (
      <>
        Get up to <span className="header__badge">-70%</span> discount on our
        plans.
      </>
    )
  };

  return (
    <div className="header">
      <h1 className="header__title">{copy.title}</h1>
      <Spacer top={8} />
      <p className="header__description">{copy.description}</p>
    </div>
  );
};

export default Header;
